import { PermissionRoles } from "@/enum";
import { CourseProgressEnum } from "@/enum/course-progress.enum";
import { PARTICIPANT_PERMISSION_NONE } from "@/pages/Private/pages/Course/components/SelectParticipantPermission";
import { CourseStatus } from "@/pages/Private/pages/Courses/enums/CourseStatus.enum";

export default {
	translation: {
		kpiDashboard: {
			all: "Alle",
			completionTime: "Abschlusszeit",
			responseTime: "Reaktionszeit",
			courses: "Szenarien",
			outcome: "Ergebnis",
			"7d": "7t",
			"30d": "30t",
			"90d": "90t",
			avgResponseTimeInfo:
				"Einschließlich erfolgreicher, fehlgeschlagener und abgebrochener Ergebnisse",
			avgPathDeviationInfo: "Nur erfolgreiche Ergebnisse eingeschlossen",
			avgCompletionTimeInfo:
				"Vom Start des Szenarios durch den Leiter bis zum Ende des Durchlaufs, einschließlich der Wartezeit, bis alle beigetreten sind. Nur erfolgreiche und fehlgeschlagene Ergebnisse",
			avgComparisonInfo:
				"Die Reaktionszeit umfasst erfolgreiche, fehlgeschlagene und abgebrochene Ergebnisse, während die Abschlusszeit nur erfolgreiche und fehlgeschlagene Ergebnisse umfasst",
			vsPreviousPeriod: "im Vergleich zum vorherigen Zeitraum",
			failedScenarios: "Fehlgeschlagene Szenarien",
			successRate: "Erfolgsquote",
			outcomeDistributionTitle: "Ergebnisverteilung pro Szenario",
			timeComparisonTitle: "Reaktions- und Abschlusszeit nach Szenario",
			resultDistributionTitle: "Ergebnisverteilung",
			pathEfficiencyTitle: "Pfadabweichung — Tatsächliche vs. Optimale Schritte",
			"indeterminate outcome": "Abgebrochen",
			runs: "Durchläufe",
			actualStages: "Tatsächliche Schritte",
			optimalStages: "Optimale Schritte",
			pageTitle: "KPI-Dashboard",
			title: "KPI-Dashboard",
			subtitle: "Leistungskennzahlen für Szenarien Ihrer Organisation",
			avgCompletionTime: "Durchschn. Abschlusszeit",
			avgResponseTime: "Durchschn. Reaktionszeit",
			avgPathDeviation: "Durchschn. Abweichung vom Pfad",
			pathDeviation: "Abweichung vom Pfad",
			totalScenarios: "Gesamtanzahl Szenarien",
			stages: "Phasen",
			trendTitle: "Leistung im Zeitverlauf",
			perScenarioTitle: "Aufschlüsselung nach Szenario",
			scenario: "Szenario",
			total: "Gesamt",
			date: "Datum",

			success: "Erfolgreich",
			failed: "Fehlgeschlagen",
			noData: "Keine Daten für diesen Zeitraum verfügbar",
			deleteData: "KPI-Daten löschen",
			day: "Tag",
			week: "Woche",
			custom: "Benutzerdefiniert",
			deleteKPITitle: "KPI-Daten löschen",
			deleteKPIWarning: "Bitte bestätigen Sie die Löschung Ihrer gespeicherten KPI-Daten.",
			deleteKPIConfirm: "Bestätigen",
		},

		companies: {
			title: "Organisationen verwalten",
			subtitle: "Verwalten Sie Ihre Teams und Benutzerberechtigungen.",
			search: "Nach Organisation suchen",
			name: "Name",
			linkedinUrl: "LinkedIn URL",
			users: "Benutzer",
			"not-activated": "AI-Funktionen nicht aktiviert",
			create: {
				button: "Neue Organisation hinzufügen",
				title: "Neue Organisation hinzufügen",
			},
			delete: {
				title: "Unternehmen löschen",
			},
			update: {
				title: "Unternehmen aktualisieren",
			},
			activated: "AI-Funktionen aktiviert",
		},
		defaultParticipants: {
			title: "Standardteilnehmer",
			yesterday: "Gestern",
			description: "Wiederverwendbare Teilnehmervorlagen für die Szenarien Ihres Unternehmens.",
			selectParticipants: "Standardteilnehmer für dieses Szenario auswählen",
			addParticipant: "Teilnehmer hinzufügen",
			editParticipant: "Teilnehmer bearbeiten",
			internalRole: "Interne Rolle",
			lastUsed: "Zuletzt verwendet am",
			notUsed: "Noch nie verwendet",
			deleteRecentlyUsedTitle: "Sind Sie sicher?",
			deleteRecentlyUsedWarning: "Dieser Teilnehmer wurde kürzlich genutzt.",
			scenarioRoles: "Szenariorollen",
			scenarioRolesHint: "Rollen durch Kommas trennen (z. B. role1, role2).",
			companyOwnership: "Unternehmenszugehörigkeit",
			noParticipants: "Noch keine Standardteilnehmer vorhanden.",
			loadError:
				"Die Standardteilnehmer konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
		},
		company: {
			general: "Allgemeine Einstellungen",
			title: "Organisationen verwalten",
			subtitle: "Verwalten Sie hier Ihre Teammitglieder und deren Kontoberechtigungen.",
			tabs: {
				general: "Allgemein",
				user: "Benutzer",
				roles: "Rollen",
			},
			kpiCollection: {
				title: "KPI-Datenerfassung",
				description:
					"Wenn aktiviert, werden Leistungskennzahlen (KPIs) Ihrer Organisation gesammelt, um Trends zu analysieren und die Dienste zu verbessern. Alle Daten werden anonymisiert, und es werden keine personenbezogenen Informationen gespeichert. Sie können die KPI-Erfassung jederzeit deaktivieren, jedoch werden weiterhin anonyme Nutzungsstatistiken für allgemeine Analysen erfasst.",
				label: "KPI-Datenerfassung aktivieren",
			},
			companyInformation: "Firmeninformationen",
			autoInvite: "Autoeinladung zur Firmen Linkedin Page",
			apolloApiKey: "Apollo API Schlüssel",
			lemlistApiKey: "Lemlist API Schlüssel",
			"invite-company-members": "Unternehmensmitglieder einladen",
			"invite-company-members-description": "Laden Sie Ihre Kollegen zur Mitarbeit ein.",
			"add-another": "Weitere hinzufügen",
			"send-invite": "Einladung verschicken",
			"company-members": "Mitglieder der Gesellschaft",
			"company-member-description":
				"Verwalten Sie Ihr bestehendes Team und ändern Sie Rollen/Berechtigungen.",
		},
		videoWizard: {
			title: "Video-Assistent",
			subtitle:
				"Geführter Ablauf in 6 Schritten — auf jedem Schritt: transparentes Modell, Kostenschätzung vorab, tatsächliche Kosten danach.",
			backToScenario: "Zurück zum Szenario",
			languages: {
				DE: "Deutsch",
				EN: "Englisch",
			},
			status: {
				notStarted: "Noch nicht gestartet",
				// Nicht "In Bearbeitung": das las sich, als arbeite das System (BCM360-373).
				awaitingApproval: "Freigabe offen",
			},
			stepper: {
				running: "Läuft …",
				approved: "freigegeben",
				// "in Arbeit" las sich wie ein laufender Job, auch auf gesperrten Schritten (BCM360-373).
				awaitingApproval: "Freigabe offen",
				waitingFor: "wartet auf Schritt {{step}}",
				pending: "offen",
				approvedCost: "{{amount}} · freigegeben",
				spentSoFar: "{{amount}} bisher",
				estimated: "geschätzt ~{{amount}}",
				lockedHint: "Bitte zuerst den vorherigen Schritt abschließen.",
			},
			modelRow: {
				// Nicht "KI-Modell": im Schnitt-Schritt steht hier die FFmpeg-Render-Pipeline.
				label: "Modell für diesen Schritt",
				placeholder: "Modell wählen",
				estimate: "Schätzung: ~{{amount}} / Durchlauf",
				actual: "Tatsächlich bisher: {{amount}} ({{times}}×)",
				noCostYet: "Noch keine Kosten angefallen",
			},
			units: {
				PER_IMAGE: "/ Bild",
				PER_SECOND: "/ Sekunde",
				PER_SCENE: "/ Szene",
				PER_1K_TOKENS: "/ 1.000 Tokens",
				PER_TRACK: "/ Sprecherspur",
				PER_EXPORT: "/ Export",
			},
			rail: {
				videoCosts: "Kosten dieses Videos",
				generationCount: "{{times}}× generiert",
				actualSoFar: "Bisher tatsächlich",
				forecast: "Prognose gesamt",
				budgetHint: "{{percent}} % des Kalkulationsrahmens ({{min}}–{{max}} pro 30-s-Video)",
				scenarioCosts: "Kosten Szenario gesamt",
				thisVideo: "Video (dieser Assistent)",
				phaseMedia: "Phasen-Medien (Bilder & TTS)",
				scenarioTotal: "Szenario gesamt",
			},
			archive: {
				button: "Archivieren",
				title: "Assistent archivieren?",
				body: "Der Assistent wird beendet und archiviert. Er lässt sich danach nicht mehr öffnen oder fortsetzen.",
				costsRemain: "Nichts wird gelöscht; die angefallenen Kosten bleiben erfasst.",
				introStays: "Ein bereits verknüpftes Intro-Video bleibt am Szenario.",
				newStart: "Ein neuer Start für dieses Szenario beginnt mit einem leeren Assistenten.",
				confirm: "Archivieren",
				cancel: "Abbrechen",
				workInFlight: "Archivieren ist möglich, sobald keine Generierung mehr läuft.",
			},
			confirmReset: {
				title: "Nachfolgende Schritte zurücksetzen?",
				body: "Dieser Schritt ist bereits freigegeben. Eine neue Generierung setzt alle nachfolgenden Schritte zurück.",
				affectedSteps: "Betroffene Schritte: {{steps}}",
				costsRemain: "Bereits angefallene Kosten bleiben erfasst.",
				confirm: "Fortfahren",
				cancel: "Abbrechen",
			},
			errors: {
				couldNotStart: "Der Assistent konnte nicht gestartet werden.",
				staleVersion:
					"Der Assistent wurde an anderer Stelle geändert. Der aktuelle Stand wurde neu geladen.",
				generic: "Die Aktion konnte nicht ausgeführt werden.",
				jobFailed: "Die Generierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
				providerModerated:
					"Der Sicherheitsfilter des Anbieters hat diese Anfrage abgelehnt. Formulieren Sie die Szenenbeschreibung um und starten Sie die Generierung erneut.",
				sessionArchived:
					"Dieser Assistent wurde archiviert und kann nicht mehr bearbeitet werden. Starten Sie im Szenario einen neuen.",
				providerImageRefused:
					"Das Videomodell hat das Startbild dieser Szene abgelehnt, weil darauf eine reale Person zu sehen sein könnte. Wählen Sie oben unter „Modell für diesen Schritt“ ein anderes Modell, oder erzeugen Sie das Bild in Schritt 2 ohne erkennbares Gesicht neu. Ein unveränderter zweiter Versuch wird ebenso abgelehnt.",
			},
			steps: {
				storyboard: {
					title: "Storyboard",
					heading: "1 · Storyboard",
					description:
						"Prompt und Ziellänge eingeben — das Sprachmodell erstellt eine Storyboard-Beschreibung mit klaren Anweisungen pro Szene: was zu sehen ist und wie lang sie ist. Iterieren Sie, bis Sie zufrieden sind.",
					approvedBadge: "✓ Freigegeben",
					promptLabel: "Prompt",
					promptPlaceholder:
						"Szenario beschreiben … z. B. „Nächtlicher Chemieunfall in einer Lagerhalle: Alarmierung, Anfahrt, erste Lageerkundung, Übergabe an die Übungsteilnehmer.“",
					lengthLabel: "Ziellänge",
					lengthOption: "{{seconds}} Sekunden",
					lengthHint: "Vordefinierte Längen — steuert Anzahl & Dauer der Szenen.",
					languageLabel: "Sprache",
					languageHint:
						"Sprache von Sprechertext und Untertiteln. Hier gewählt, weil die Szenen darin geschrieben werden — eine spätere Änderung schreibt sie neu.",
					generate: "Storyboard generieren",
					promptRequired:
						"Erst verfügbar, wenn ein Szenario-Prompt geschrieben ist — ohne ihn erfindet das Modell ein Szenario.",
					durationBounds: "{{min}}–{{max}} s",
					generating: "Storyboard wird generiert …",
					empty:
						"Noch kein Storyboard. Prompt und Ziellänge festlegen und generieren — das Sprachmodell liefert pro Szene eine klare Anweisung, was zu sehen ist und wie lang sie ist.",
					versionHeading: "Storyboard — Version {{version}} · {{note}}",
					noNote: "ohne Notiz",
					sceneTitle: "Titel der Szene",
					sceneDescription: "Beschreibung der Szene",
					sceneDuration: "Dauer der Szene in Sekunden",
					seconds: "s",
					addScene: "Szene hinzufügen",
					removeScene: "entfernen",
					totalLength: "Gesamtlänge: {{seconds}} s",
					targetMet: "Ziel: {{seconds}} s ✓",
					targetMissed: "Ziel: {{seconds}} s — anpassen oder neu generieren",
					iterateHeading: "Iterieren, bis es passt",
					iterations_one: "{{count}} Iteration",
					iterations_other: "{{count}} Iterationen",
					feedbackPlaceholder:
						"Änderungswunsch beschreiben … z. B. „Szene 2 aus der Perspektive der Einsatzkräfte zeigen und die Gesamtlänge exakt auf 30 s bringen“",
					regenerate: "Neu generieren mit Feedback",
					approve: "Storyboard freigeben → Stil wählen",
					approveBlockedHint: "Die Gesamtlänge muss der Ziellänge exakt entsprechen.",
				},
				style: {
					title: "Stil & Beispielbilder",
					heading: "2 · Grafischer Stil & Beispielbilder",
					description:
						"Erst nach Freigabe des Storyboards: Stil wählen (realistisch, Schwarz-Weiß, …). Ergebnis pro Szene: Beispielbild + Szenenbeschreibung. Jedes Bild ist einzeln iterierbar.",
					approvedBadge: "✓ Freigegeben",
					styleLabel: "Grafischer Stil",
					styleHint:
						"Der Stil wird als gemeinsamer Look auf alle Szenen angewendet — sorgt für Konsistenz über das gesamte Video.",
					styles: {
						photo: { name: "Fotorealistisch", hint: "Wie fotografiert, natürliches Licht" },
						bw: { name: "Schwarz-Weiß", hint: "Kontraststark, ohne Farbe" },
						illu: { name: "Illustration", hint: "Klare Konturen, flächige Farben" },
						"3d": { name: "3D-Render", hint: "Technische Visualisierung" },
						aqua: { name: "Aquarell", hint: "Weiche Flächen, zurückgenommen" },
						doku: { name: "Doku / Archiv", hint: "Entsättigt, Reportage-Anmutung" },
					},
					staleNotice: "🎨 Stil geändert — Bilder neu generieren, um ihn anzuwenden.",
					empty:
						"Noch keine Beispielbilder. Stil wählen und generieren — Ergebnis: pro Szene ein Beispielbild + Szenenbeschreibung, die spätere Grundlage der Videogenerierung (Image-to-Video).",
					generateAll: "{{scenes}} Beispielbilder generieren",
					resultHeading:
						"Ergebnis: Beispielbild + Szenenbeschreibung — pro Szene iterieren, bis es passt",
					sceneNumber: "Szene {{number}} · {{seconds}} s",
					sceneGenerating: "generiert …",
					sceneReady: "✓ generiert",
					sceneStale: "Stil geändert — neu generieren",
					sceneEmpty: "Noch kein Bild",
					sceneFeedbackLabel: "Feedback zu Szene {{number}}",
					sceneFeedbackPlaceholder: "Feedback zu diesem Bild …",
					sceneRegeneratingWith: "Wird neu generiert mit:",
					uploadStyle: "Bildstil analysieren",
					sourceComputer: "Vom Computer hochladen",
					sourceLibrary: "Aus der Mediathek wählen",
					uploadStyleHint: "oder den Look aus einem eigenen Bild übernehmen",
					uploadedStyle: "Hochgeladener Stil",
					uploadedAnalysing: "Look wird gelesen …",
					uploadedReady: "Look aus Ihrem Bild gelesen",
					uploadedFailed: "Aus diesem Bild ließ sich kein Stil lesen.",
					uploadFailed: "Das Bild konnte nicht hochgeladen werden. Bitte erneut versuchen.",
					fragmentLabel: "Stilbeschreibung für alle Szenen",
					fragmentPlaceholder: "Wie die Szenen aussehen sollen …",
					fragmentEdited: "bearbeitet",
					fragmentHint:
						"Dieser Text geht an das Bildmodell, nicht das Bild selbst. Beim Bearbeiten werden die Bilder dieses Stils zur Neugenerierung markiert.",
					downloadImage: "Herunterladen",
					regenerateScene: "Bild neu",
					iterateHeading: "Alle Szenen gemeinsam iterieren",
					iterations_one: "{{count}} Bild generiert",
					iterations_other: "{{count}} Bilder generiert",
					feedbackPlaceholder:
						"Übergreifendes Feedback … z. B. „insgesamt dunkler, mehr Regen, weniger Personen im Bild“",
					regenerateAll: "Alle Bilder neu generieren",
					approve: "Bilder freigeben → Sprecher & Audio",
					approveBlockedHint:
						"Erst verfügbar, wenn jede Szene ein aktuelles Bild im gewählten Stil hat.",
				},
				narration: {
					title: "Narration",
					heading: "3 · Narration",
					description:
						"Der Sprechertext wird geschrieben und geprüft: Länge, Ton und Sprache. Iterieren Sie mit Feedback, bis der Text passt — vertont wird er erst im nächsten Schritt, das Iterieren kostet hier also keine Sprecherspur.",
					approvedBadge: "✓ Freigegeben",
					generatingBadge: "Sprechertext wird geschrieben",
					governanceHeading: "Sprechertext & Prüfung",
					governanceHint:
						"Jeder Sprechertext wird auf Sprache, Länge, Ton, Sicherheit und Format geprüft.",
					sceneNumber: "Szene {{number}} · {{title}}",
					checkPassed: "Prüfung bestanden",
					checkFailed: "Prüfung nicht bestanden",
					wordCount: "{{words}} von {{target}} Zielwörtern",
					repaired: "{{times}}× korrigiert",
					rules: {
						format: "Format",
						language: "Sprache",
						length: "Länge",
						tone: "Ton",
						safety: "Sicherheit",
					},
					iterateHeading: "Text generieren & iterieren",
					sceneFeedbackPlaceholder:
						"Feedback nur für diese Szene, z. B. „knapper, weniger Fachbegriffe“ …",
					regenerateScene: "Diese Szene neu schreiben",
					editText: "Text bearbeiten",
					saveText: "Übernehmen",
					cancelEdit: "Abbrechen",
					briefLabel: "Vorgaben für den Sprechertext",
					briefHint:
						"Was für ein Text es werden soll — Ton, Zielgruppe, Schwerpunkte. Gilt für jede Generierung, bis Sie es ändern.",
					briefPlaceholder:
						"z. B. „direkte Ansprache, Fokus auf Eigenschutz, für neue Mitarbeitende ohne Vorwissen“ …",
					generate: "Sprechertext generieren",
					regenerate: "Neu generieren",
					generating: "Sprechertext wird geschrieben …",
					generatingHint:
						"Der Text wird geschrieben und geprüft. Sobald er vorliegt, können Sie ihn lesen, iterieren und freigeben.",
					generateHint:
						"Erzeugt den kompletten Sprechertext für alle Szenen. Danach lesen, bei Bedarf mit Feedback iterieren und freigeben.",
					feedbackPlaceholder:
						"Anmerkungen für die nächste Fassung, z. B. „weniger förmlich“ oder „die erste Szene knapper“ …",
					approve: "Freigeben → Audio",
					approveBlockedChecks:
						"Erst verfügbar, wenn jede Szene ihre Prüfung besteht — ein zu langer Text würde im Video abgeschnitten.",
				},
				audio: {
					title: "Audio",
					heading: "4 · Audio",
					description:
						"Sprecherstimme (Deutsch wird vollständig unterstützt und erzwungen) und Untertitel-Stil festlegen, dann den freigegebenen Sprechertext vertonen. Stimme oder Untertitel später zu ändern kostet nur eine neue Vertonung — der Text bleibt.",
					approvedBadge: "✓ Freigegeben",
					generatingBadge: "Sprecherspur wird generiert",
					languageLabel: "Sprache der Narration",
					languageSupported: "Mehrsprachige Stimmen — jede kann {{language}} sprechen",
					voiceLabel: "Sprecherstimme",
					noVoice: "Noch keine Stimme gewählt",
					noVoiceHint: "Ohne Stimme kann die Sprecherspur nicht erzeugt werden.",
					voiceChosen: "Diese Stimme liest den gesamten Sprechertext.",
					chooseVoice: "Stimme wählen",
					changeVoice: "Stimme ändern",
					subtitleLabel: "Untertitel-Stil",
					subtitleNoneSample: "— keine Untertitel —",
					subtitleStyles: {
						NONE: "Keine",
						CLASSIC: "Klassisch (Balken)",
						WORD_HIGHLIGHT: "Modern (Wort-Highlight)",
					},
					positionLabel: "Position",
					positions: {
						BOTTOM_CENTER: "Unten zentriert",
						BOTTOM_LEFT: "Unten links",
						TOP_CENTER: "Oben zentriert",
					},
					sizeLabel: "Größe",
					sizes: { S: "Klein", M: "Mittel", L: "Groß" },
					sceneNumber: "Szene {{number}} · {{title}}",
					trackHeading: "Vertonte Szenen",
					trackHint: "Jede Szene mit ihrer gesprochenen Spur — anhören, bevor Sie freigeben.",
					iterateHeading: "Sprecher-Vorschau & Freigabe",
					prices: "Vorschau: ~{{preview}} · komplette Spur: ~{{track}}",
					preview: "Vorschau mit Stimme „{{voice}}“ anhören",
					previewRunning: "Vorschau wird erzeugt …",
					approve: "Freigeben → Szenen-Videos",
					generate: "Vertonung generieren",
					regenerate: "Neu vertonen",
					generating: "Sprecherspur wird generiert …",
					generatingHint:
						"Der freigegebene Sprechertext wird mit der gewählten Stimme vertont. Sobald die Spur fertig ist, können Sie sie anhören und freigeben.",
					generateHint:
						"Vertont den freigegebenen Sprechertext mit der gewählten Stimme. Danach anhören und freigeben.",
					approveBlockedHint: "Erst verfügbar, wenn eine Sprecherstimme gewählt ist.",
					noScriptHint: "Erst verfügbar, wenn der Sprechertext (Schritt 3) vorliegt.",
				},
				sceneVideos: {
					title: "Szenen-Videos",
					heading: "5 · Szenen-Videos generieren",
					noVoiceHint:
						"Hinweis: Diese Clips enthalten nur die Umgebungsgeräusche des Videomodells, noch keine Sprecherstimme. Die in Schritt 4 erzeugte Sprecherspur wird beim Export pro Szene daruntergelegt und auf den Zuschnitt getimt.",
					description:
						"Jede Szene wird separat generiert. Ergebnis pro Szene: Video + Szenenbeschreibung. Einzeln iterieren und freigeben — erst dann geht es zum Schnitt.",
					approvedBadge: "✓ Freigegeben",
					renderingBadge_one: "● {{count}} Szene rendert",
					renderingBadge_other: "● {{count}} Szenen rendern",
					reviewBadge: "In Prüfung",
					empty:
						"Noch keine Szenen-Videos. Jede Szene wird separat aus ihrem freigegebenen Beispielbild generiert (Image-to-Video) — die Sprecherspur wird beim Export pro Szene getimt.",
					generateAll: "Alle {{scenes}} Szenen generieren",
					asyncHint:
						"Asynchrone Jobs: jede Szene rendert einzeln und erscheint hier, sobald sie fertig ist. Sie können die Seite währenddessen verlassen.",
					resultHeading: "Szenen einzeln prüfen und freigeben",
					sceneNumber: "Szene {{number}} · {{seconds}} s",
					sceneGenerating: "rendert …",
					sceneReady: "Prüfung offen",
					sceneApproved: "✓ freigegeben",
					sceneStale: "Bild geändert — neu generieren",
					sceneEmpty: "Noch kein Video",
					sceneCost: "Kosten: {{amount}} ({{times}} Renders)",
					sceneFeedbackLabel: "Feedback zu Szene {{number}}",
					sceneFeedbackPlaceholder: "Bewegung, Kamera, Geräusche … z. B. „langsamere Kamerafahrt“",
					sceneRegeneratingWith: "Wird neu generiert mit:",
					regenerateScene: "Neu generieren",
					// No "✓" here — the button already carries the check icon.
					approveScene: "Szene freigeben",
					iterateHeading: "Weiter, wenn alle Szenen freigegeben sind",
					progress: "{{approved}} von {{scenes}} freigegeben",
					progressRendering: "{{approved}} von {{scenes}} freigegeben · {{times}} rendert",
					feedbackPlaceholder:
						"Übergreifendes Feedback zu Bewegung, Kamera und Umgebungsgeräuschen … z. B. „insgesamt ruhigere Kamerafahrten, weniger Bewegung im Bild“",
					feedbackHint:
						"Jede Szene wird aus ihrem freigegebenen Bild aus Schritt 2 animiert: Feedback hier steuert Bewegung, Kamera und Umgebungsgeräusche — nicht den Look. Ein anderer Look heißt, das Bild in Schritt 2 neu zu generieren, was das Video ohnehin ersetzt.",
					regenerateAll: "Alle Szenen neu generieren",
					approve: "Alle Szenen freigegeben → Schnitt & Export",
					approveBlockedHint:
						"Der Schnitt-Schritt wird freigeschaltet, sobald alle {{scenes}} Szenen einzeln freigegeben wurden.",
				},
				cutExport: {
					title: "Schnitt & Export",
					heading: "6 · Schnitt & Export",
					description:
						"Alle Szenen zu einem Video zusammenfügen. Clip in der Timeline anklicken und im Schnitt-Editor mit den Griffen Anfang und Ende herausschneiden; Reihenfolge per Drag & Drop oder ◀ ▶ ändern.",
					locked: "Wird freigeschaltet, sobald alle Szenen-Videos freigegeben sind.",
					awaitingApprovalBadge: "Freigabe offen",
					renderingBadge: "● Video wird zusammengefügt",
					exportedBadge: "✓ Exportiert",
					timelineHeading: "Timeline",
					timelineHint:
						"Clip anklicken zum Schneiden · ziehen (oder ◀ ▶) zum Umsortieren. Herausgeschnittene Bereiche sind schraffiert.",
					total: "Gesamt: {{total}} (Ziel {{target}} s)",
					unsaved: "Nicht gesichert",
					saveNow: "Schnitt jetzt sichern",
					clipLabel: "Szene {{number}}",
					clipTrimmed: "{{kept}} (von {{total}})",
					clipHint: "Anklicken zum Schneiden · Ziehen zum Umsortieren",
					moveLeft: "Szene {{number}} nach links",
					moveRight: "Szene {{number}} nach rechts",
					trimHeading: "✂ Schneiden: Szene {{number}} · {{title}}",
					// Spielt den Zuschnitt mit Stimme und Untertiteln — mehr als nur den Schnitt.
					playTrim: "Ergebnis ansehen",
					resetClip: "Zurücksetzen",
					handleIn: "Anfang des Zuschnitts",
					handleOut: "Ende des Zuschnitts",
					trimStart: "Anfang",
					trimEnd: "Ende",
					nudgeMinus: "−0,2 s",
					nudgePlus: "+0,2 s",
					kept: "Behalten: {{kept}} von {{total}}",
					voiceHeading: "Sprecherspur",
					voiceHint:
						"Block verschieben: die Stimme später einsetzen lassen. Kanten ziehen: Anfang oder Ende der Aufnahme abschneiden. Untertitel folgen der Stimme automatisch; abgeschnittene Sprache wird beim Export gemeldet.",
					voiceMissing:
						"Für diese Szene liegt noch keine Sprecherspur vor — erzeugen Sie sie in Schritt 4.",
					voicePlay: "▷ Anhören",
					voiceReset: "↺ Sprecherspur zurücksetzen",
					voiceOffset: "Einsatz",
					voiceKept: "Sprache: {{kept}} von {{total}}",
					voiceBlock: "Sprecherspur positionieren",
					voiceCutHead: "Anfang der Aufnahme abschneiden",
					voiceCutTail: "Ende der Aufnahme abschneiden",
					trimHint:
						"Griffe mit der Maus ziehen oder per Knopf feinjustieren — herausgeschnittene Bereiche sind schraffiert (Mindestlänge {{min}} s). Sprecherspur und Untertitel werden beim Export automatisch neu getimt.",
					exportHeading: "Zusammenfügen & exportieren",
					transitionLabel: "Übergänge",
					transitions: {
						HARD_CUT: "Harter Schnitt",
						CROSSFADE_04: "Weiche Blende (0,4 s)",
						FADE_BLACK: "Schwarzblende",
					},
					destinationLabel: "Verwendung",
					destinationIntro: "Als Intro-Video des Szenarios",
					destinationLibrary: "Nur in der Medienbibliothek",
					destinationIntroHint:
						"Das fertige Video wird als Intro des Szenarios verknüpft und ersetzt ein bisheriges.",
					destinationLibraryHint:
						"Das fertige Video landet in der Medienbibliothek. Von dort können Sie es als Intro, als Phaseninhalt oder in einem anderen Szenario verwenden.",
					formatsLabel: "Ausgabeformate",
					formatsHint:
						"Ein Render-Job deckt alle gewählten Formate ab — der Export ist pauschal bepreist, egal in wie viele Formate er schreibt.",
					formatChip: "{{label}} · {{width}}×{{height}}",
					export: "Zusammenfügen & exportieren",
					exportAgain: "Neu exportieren",
					exporting: "Wird zusammengefügt …",
					exportHint:
						"Der Render läuft im Hintergrund: Zuschnitte, Sprecherspur, Musik und Untertitel werden zusammengeführt. Sie können die Seite währenddessen verlassen.",
					finishedHeading: "Fertiges Intro-Video",
					linkedBadge: "✓ Als Intro des Szenarios verknüpft",
					libraryBadge: "✓ In der Mediathek gespeichert",
					// Export-Warnungen, hier aus Code und Details formuliert — die Server-
					// Nachricht ist nur der Fallback.
					warningTexts: {
						NARRATION_TRUNCATED:
							"Von der Sprecherspur zu „{{sceneTitle}}“ ({{takeSeconds}} s) sind {{droppedSeconds}} s nicht im fertigen Video zu hören — der Zuschnitt ist {{keptSeconds}} s lang und die Sprecherspur ist darin beschnitten oder verschoben.",
						TRANSITION_SHORTENED:
							"Weiche Blenden überlappen die Clips: das fertige Video ist {{seconds}} s kürzer als die Summe der Zuschnitte.",
						SUBTITLE_STYLE_FALLBACK:
							"Für {{scenes}} liegen keine Wort-Zeitstempel vor — diese Untertitel wurden klassisch gesetzt. Erzeugen Sie die Sprecherspur neu, um Wort-Highlights zu erhalten.",
						MUSIC_UNAVAILABLE:
							"Die gewählte Hintergrundmusik konnte nicht geladen werden — das Video wurde ohne Musik erzeugt.",
					},
					subtitleTrackLabel: "Deutsch",
					subtitleDownload: "Untertiteldatei (.vtt)",
					downloadButton: "Herunterladen",
				},
			},
		},
		courses: {
			inviteText:
				"Um an der Übung teilzunehmen, klicken Sie auf diesen Link: {{link}},\nAuthentifizieren Sie sich mit Ihrer PIN: {{code}}",
			joined: "Beigetreten",
			externalInviteInfo:
				"Teilen Sie den untenstehenden Link, um Kollegen außerhalb Ihres vordefinierten Teams einzuladen. Sie können dem Szenario beitreten und daran mitarbeiten, werden jedoch nicht in die Reaktionszeit-KPIs einbezogen.",
			pending: "Ausstehend",
			invited: "Eingeladen",
			left: "Verlassen",
			sortingOptions: {
				name: "Nach Namen sortieren",
				date: "Nach Datum sortieren",
			},
			template: "Vorlage",
			"scenario-generation-started":
				"Szenario-Generierung gestartet. Sie erhalten eine E-Mail, sobald es fertig ist.",
			leadsToPhase: "Führt zur Phase",
			effects: {
				tvGlitch: "TV-Glitch Effekt",
				drone: "Drohnen Effekt",
			},
			title: "Szenarien",
			subtitle:
				"Wählen, analysieren oder erstellen Sie neue Szenarien, um verschiedene Situationen zu üben, Entscheidungen zu treffen und Reaktionsstrategien zu verbessern.",
			subtitleChooseOnly:
				"Wählen Sie ein Szenario aus, um verschiedene Situationen zu üben, Entscheidungen zu treffen und Reaktionsstrategien zu verbessern.",
			search: "Suche nach Szenario",
			name: "Name",
			tags: "Tag",
			description: "Beschreibung",
			"for-whom": "Für wen",
			status: "Status",
			[CourseStatus.Active]: "Aktiv",
			[CourseStatus.Draft]: "Entwurf",
			users: "Benutzer",
			json: "JSON-Eingabe",
			"invalid-email": "Ungültige E-Mail-Adresse",

			"next-phase": "Next Phase",
			industry: "Branche",
			"companySize-label": "Unternehmensgröße",
			primaryIncidentType: "Primärer Vorfallstyp",
			specificCompanyDeficits: "Spezifische Unternehmensdefizite (optional)",
			specificDeficits: {
				inadequatePlans: "Unzureichende Notfallpläne",
				overburdenedRoles: "Überlastete wichtige Rollen (z.B. CEO, Leitung des Krisenmanagements)",
				outdatedInfrastructure: "Veraltete IT-Infrastruktur",
				lackOfCommunication: "Mangel an interner Kommunikation / Silo-Denken",
				supplierDependence: "Hohe Abhängigkeit von einzelnen Lieferanten",
			},
			specificNotes: "Weitere spezifische Anmerkungen (optional)",
			"specificNotes-placeholder":
				"z.B. Betroffene Systeme, geografischer Standort, regulatorische Anforderungen, spezifische Schwachstellen, die nicht oben gelistet sind.",
			create: {
				button: "Neues Szenario erstellen",
				title: "Neues Szenario erstellen",
				"creation-description":
					"Wählen Sie, wie Sie das Szenario erstellen möchten? Es stehen zwei Optionen zur Verfügung: \n- Manuell, bei der Sie alles selbst ausfüllen \n- Automatisch, mit Hilfe von generativer KI, bei der Sie nur einige Parameter angeben müssen",
				"choose-creation-flow": "Erstellungsprozess wählen",
				"manual-creation": "Manuelle Erstellung",
				"generative-ai": "Generative KI",
			},
			companySize: {
				small: "Klein (1-50 Mitarbeiter)",
				medium: "Mittel (51-500 Mitarbeiter)",
				large: "Groß (501-4999 Mitarbeiter)",
				veryLarge: "Sehr groß (5000+ Mitarbeiter)",
			},
			incidentType: {
				cyberAttack: "Cyberattacke (z.B. Ransomware, Datenlecks)",
				naturalDisaster: "Naturkatastrophe (z.B. Erdbeben, Hurrikan, Flut)",
				pandemic: "Pandemie / Gesundheitskrise",
				supplyChainDisruption: "Signifikante Störung der Lieferketten",
				utilityFailure: "Ausfall kritischer Dienste (z.B. Strom, Wasser, Internet)",
				physicalSecurityIncident: "Physische Sicherheitsvorfälle (z.B. unbefugte Zugang, Sabotage)",
				terrorism: "Terrorismus / Zivilunruhe",
				equipmentFailure: "Ausfall kritischer Ausrüstung oder Infrastruktur",
				personnelLoss: "Plötzlicher Verlust wichtiger Mitarbeiter",
				financialCrisis: "Schwere finanzielle Krise / Marktkrise",
			},
			language: {
				language: "Sprache",
				select: "Wählen Sie eine Sprache aus",
				label: "In welcher Sprache soll das Szenario generiert werden?",
				english: "Englisch",
				deutsch: "Deutsch",
				all: "Alle",
			},
			generate: {
				title: "Szenario generieren",
				errors: {
					industry: "Branche ist erforderlich",
					companySize: "Unternehmensgröße ist erforderlich",
					primaryIncidentType: "Primäre Vorfallart ist erforderlich",
				},
			},
			delete: {
				title: "Szenario löschen",
			},
			update: {
				title: "Update-Szenario",
				text: "Text",
				json: "JSON",
			},
			duplicate: {
				duplicateScenario: "Szenerio duplizieren",
				newTitle: "Neuer Titel",
				copy: "Kopie",
			},
			uploadedFiles: {
				selectFile: "Eine Datei zum Hochladen für dieses Szenario auswählen",
			},
			generalInvite: "Allgemeine einladung",
			start: {
				title: "Start-Szenario",
				label: "Szenario zum Starten auswählen",
				"please-select": "Bitte wählen Sie ein Szenario",
				versionLabel: "Zu startende Fassung",
				versionHint:
					"Nur für Sie sichtbar. Alle anderen starten immer die veröffentlichte Fassung — auch in VR.",
				publishedVersion: "Veröffentlichte Fassung",
				draftVersion: "Entwurf — nicht veröffentlicht",
				versionFallback: "Version {{id}}",
				"start-training-description":
					'Möchten Sie wirklich ein Szenario mit dem Namen "{{trainingName}}" starten?',
				"invite-colleagues-title": "Team einladen",
				"invite-colleagues-description":
					"Laden Sie Ihr vordefiniertes Team ein, um an diesem Szenario zusammenzuarbeiten. Klicken Sie auf die Kopieren-Schaltfläche, um den Code und den Link mit Ihren Kollegen zu teilen. Deren Reaktionszeiten werden für KPI-Berichte erfasst.",
			},
			upload: {
				title: "Zum Hochladen klicken oder ziehen und ablegen",
				description: "(bis zu {{sizeInMB}} MB)",
				drop: "Datei hier ablegen",
				modalTitle: "Dateien hochladen",
				modalBtn: "Hochladen",
			},
			progress: {
				content: "Inhalt",
				whiteboard: "Whiteboard",
				pages: "Seiten",
				emptyCanvas: "Leere Leinwand",
				startDrawing: "Mit dem Zeichnen beginnen",
				stopDrawing: "Hör auf zu zeichnen",

				noFilesSelected: "Keine Datei ausgewählt",
				selectFile: "Wählen Sie eine Datei aus, die Sie mit Ihrem Team teilen möchten",
				changeFile: "Datei ändern",
				protocol: "Protokoll",
				finalDecision: {
					elaboratedDecision: "Entscheidungsdetails ",
					title: "Begründen Sie Ihre Entscheidung",
					subtitle:
						"Bitte halten Sie fest, wie Sie diese Entscheidung in Ihrer Organisation umsetzen würden.",
					placeholder: "Geben sie hier Ihren Text ein...",
				},
				tasks: "Aufgaben",
				"content-cannot-be-displayed": "Inhalt kann nicht angezeigt werden",
				"type-a-new-message": "Geben Sie eine neue Nachricht ein",
				"type-a-new-message-protocol": "Ihr Protokolleintrag",
				send: "Schreibe",
				"send-protocol": "Protokoll schreiben",
				next: "Nächste Phase",
				save: "Entscheidung speichern",
				complete: "Vervollständigen Sie das Szenario",
				restart: "Starten Sie das Szenario neu",
				information: "Informationen",
				"time-up":
					"Die Zeit läuft ab, sei vorsichtig, es sind nur noch {{leftTime}} Minuten übrig, um diese Etappe abzuschließen",
				"time-up-empty": "Die Zeit für den Abschluss der Etappe läuft ab, achten Sie auf den Timer",
				"no-content-available": "Kein Inhalt verfügbar",
				phase: "Phase",
				"no-messages-yet": "Noch keine Nachrichten vorhanden",
				you: "Sie",
				"end-session": "Sitzung beenden",
				"cant-sent-empty": "Leere Nachricht kann nicht gesendet werden",
				message: "Nachricht",
				left: "links",
				chat: "Chat",
				"add-team": "Team einladen",
				expired: "Die Einladung ist abgelaufen",
				"join-course": "Szenario beitreten",
				"first-login": {
					title: "Name festlegen",
					description: "Dies ist Ihr Name, der während des Szenarios angezeigt wird.",
					continue: "Weiter",
					"otp-title": "PIN eingeben",
					"otp-description":
						"Geben Sie die 4-stellige PIN ein, die Sie von der verantwortlichen Person erhalten haben.",
					"pin-format": "Bitte geben Sie die 4-stellige PIN ein.",
					["USER_NOT_FOUND"]: "Sie können dem Szenario nicht beitreten",
					["INVALID_OTP"]: "Diese PIN ist ungültig oder das Szenario ist bereits beendet.",
					next: "Weiter",
				},
				team: "Team",
				invited: "Eingeladen",
				"invited-users": "Eingeladen {{usersString}}",
				"user-joined": "Ist dem Szenario beigetreten.",
				"add-another": "Weitere hinzufügen",
				"unknown-content": "Unbekannter Inhalt",
				"unsupported-content-type": "Nicht unterstützter Inhaltstyp",
				permissions: {
					[PARTICIPANT_PERMISSION_NONE]: "Keine",
					[PermissionRoles.PROTOCOL_WRITER]: "Protokollführer",
					[PermissionRoles.PRESENTER]: "Moderator",
					[PermissionRoles.PARTICIPANT]: "Teilnehmer",
				},
				confirm: "Entscheidung bestätigen",
				spoiler: "Spoiler",
				"i-see": "Schließen",
				no: "Nein",
				yes: "Ja",
				"sure-want-to-view-title": "Sind Sie sicher, dass Sie den Hilfetext sehen wollen?",
				"sure-want-to-view-description":
					"Klicken Sie auf „Ja“, wenn Sie Hilfe benötigen, oder auf „Nein“, wenn Sie ohne Hilfe fortfahren möchten.",
				"requested-spoiler": "Angeforderte Hilfe für Phase {{phaseNumber}}",
				participant: "Teilnehmer",
				participants: "Teilnehmer",

				"responsible-person": "Verantwortliche Person",
				remove: "Entfernen",
				"removing-user-from-scenario": "Benutzer aus dem Szenario entfernen",
				"remove-user-description":
					"Sind Sie sicher, dass Sie den Benutzer '{{data}}' aus dem Szenario entfernen wollen?",
				"removed-user": "{{userData}} aus dem Szenario entfernt",
				// The protocol as the paper form "Ereignisdokumentation" (BCM360-376).
				form: {
					title: "Ereignisdokumentation",
					date: "Datum",
					exercise: "Übung",
					keptBy: "Protokoll führt",
					columns: {
						record: "Aufzeichnung zum Ereignis / Besprechungsprotokoll",
						time: "Uhrzeit",
						assignee: "zuständig",
						done: "erledigt",
					},
					filters: {
						all: "Alle",
						open: "Offen ({{count}})",
						done: "Erledigt",
						allPhases: "Alle Phasen",
						phase: "Phase",
					},
					phase: "Phase {{id}}",
					phaseWithName: "Phase {{id}} · {{name}}",
					clock: "{{time}} Uhr",
					writtenBy: "verfasst von {{name}}",
					editedBy: "geändert von {{name}} um {{time}}",
					decision: "Entscheidung",
					help: "Hilfe",
					chosen: "Gewählt: {{option}}",
					explanation: "Begründung: {{text}}",
					assign: "– zuweisen –",
					nobody: "– niemand –",
					assigneeHint: "Nur nötig, wenn jemand etwas erledigen soll",
					doneAt: "{{time}} Uhr",
					open: "offen",
					timeWarning_one: "Noch {{count}} Minute in dieser Phase",
					timeWarning_other: "Noch {{count}} Minuten in dieser Phase",
					timeWarningEmpty: "Die Zeit für diese Phase läuft ab",
					end: "Szenario beendet",
					placeholder: "Was ist passiert, was wurde besprochen oder beschlossen?",
					assignedToPhase: "Wird {{phase}} zugeordnet",
					shortcut: "Strg + Enter fügt hinzu",
					add: "Eintragen",
					edit: "Eintrag bearbeiten",
					save: "Speichern",
					cancel: "Abbrechen",
					empty: "Noch keine Einträge",
					emptyFilter: "Keine Einträge in diesem Filter",
					invalidTime: "Uhrzeit als HH:MM",
					textLabel: "Protokolleintrag",
					timeLabel: "Uhrzeit",
					assigneeLabel: "zuständig",
					doneLabel: "erledigt",
				},
			},
			end: {
				[CourseProgressEnum.Success]:
					'Sie haben das Szenario "{{scenarioName}}" erfolgreich abgeschlossen.',
				[CourseProgressEnum.Failed]: 'Szenario "{{scenarioName}}" wurde noch nicht abgeschlossen',
				[CourseProgressEnum.IndeterminateOutcome]:
					'Das Szenario "{{scenarioName}}" wurde abgebrochen.',
				[CourseProgressEnum.NotStarted]:
					"Das Szenario mit dieser ID wurde nicht gefunden. Stellen Sie sicher, dass die Daten korrekt sind.",
				success: "Herzlichen Glückwunsch!",
				failure: "Versagen",
				"auto-completed": "Das Szenario wurde automatisch abgeschlossen",
				"time-up": "Die für die Bühne vorgesehene Zeit war erschöpft",
				"no-info": "Es sind keine Informationen über das Ergebnis des Szenarios verfügbar.",
				"already-end": "Das Szenario ist bereits abgeschlossen",
				congratulations: "Herzlichen Glückwunsch",
				"view-all-finished-scenarios": "Alle abgeschlossenen Szenarien anzeigen",
				"go-to-scenarios-dashboard": "Zum Szenarien-Dashboard gehen",
				unfortunately: "Leider",
				"scneario-progress-not-found": "Der Szenario-Fortschritt wurde nicht gefunden",
			},
			"show-pin-title": "Meta Quest Connection PIN",
			"show-pin-description": "Enter this PIN in the input field on your Meta Quest.",
			connectAR: "connect AR",

			author: "Autor",
			phaseName: "Phasenname",
			id: "ID",
			PasteURL: "Paste URL for",
			AudioNotSupported: "Your browser does not support the audio element.",
			VideoNotSupported: "Your browser does not support the video element.",
			contentType: "Inhaltstyp",
			text: "Text",
			audio: "Audio",
			image: "Image",
			video: "Video",
			editTimeDelayedContent: "Zeitverzögerte Inhalte bearbeiten",
			editSpoiler: "Spoiler bearbeiten",
			autoplay: "Autoplay",
			phaseEndText: "Abschlussnachricht",
			phaseEndTextExplain: "Text der am Phasenende angezeigt wird",
			decisions: "Entscheidungen",
			decisionTitle: "Entscheidung",
			timeLimit: "Zeitlimit",
			inSeconds: "in Sekunden",
			TimeoutPhaseID: "Automatisch gewählte Option bei Zeitüberschreitung",
			confirmation: "Bestätigung erforderlich",
			none: "Keine",
			fromLeader: "Von Leader",
			fromAll: "Von Allen",
			decisionOptions: "Entscheidungsmöglichkeiten",
			option: "Option",
			phaseID: "Phase ID",
			spoiler: "Spoiler",
			timeDelayedContent: "Inhalt mit Zeitverzögerung",
			add: "Hinzufügen",
			remove: "Entfernen",
			content: "Inhalt",
			startTime: "Startzeit",
			endTime: "Endzeit",
			title2: "Titel",
			newOption: "Neue Option",
			UntitledScenario: "Unbenanntes Szenario",
			UnknownAuthor: "Unbekannter Autor",
			Success: "Erfolgreich",
			Failed: "Fehlschlag",
			phaseEndResult: "Phasenergebnis",
			newPhase: "Neue Phase",
			newContent: "Neuer Inhalt",
			newTitle: "Neuer Titel",
			large: "360° Video",
			forWhom: "Für wen",
			editDecision: "Entscheidung bearbeiten",
			explanation: "Erklärung",
			aiImage: {
				uploadFile: "Datei hochladen",
				generateWithAi: "Mit KI generieren",
				prompt: "Prompt",
				promptPlaceholder:
					"Beschreiben Sie das gewünschte Bild — Motiv, Perspektive, Lichtstimmung, Stil.",
				promptHint: "Exakte Ausgabemaße pro Anfrage — kein Zuschneiden nötig.",
				qualityTier: "Qualitätsstufe",
				tierBulk: "Bulk",
				tierBulkHint: "Phasen & Varianten",
				tierHero: "Hero",
				tierHeroHint: "Titel & Schlüsselszenen",
				perImage: "/ Bild",
				formats: "Formate",
				formatsHint: "(einmal generieren → mehrere Formate in einem Job)",
				formatsManagedHint:
					"Presets werden zentral unter Einstellungen → Formate & Presets verwaltet.",
				estimatedCost: "Geschätzte Kosten",
				estimateDetail: "({{variants}} Varianten × {{formats}} Formate, {{tier}})",
				priceUnverified: "Preis noch ungeprüft — Schätzung ist ein Platzhalter.",
				generate: "Bilder generieren",
				generating: "Job läuft asynchron …",
				asyncHint:
					"Asynchroner Job — die Ergebnisse erscheinen automatisch, sobald sie fertig sind.",
				results: "Ergebnisse",
				jobLabel: "Job #{{id}}",
				variant: "Variante {{index}}",
				applyVariant: "Variante {{index}} übernehmen",
				regenerate: "Neu generieren",
				cancel: "Job abbrechen",
				running: "Läuft",
				done: "Abgeschlossen",
				failed: "Fehlgeschlagen",
				cancelled: "Abgebrochen",
				noFormatSelected: "Bitte mindestens ein Format wählen.",
				promptRequired: "Bitte einen Prompt eingeben.",
				submitError: "Der Generierungs-Job konnte nicht gestartet werden.",
				selectError: "Die Variante konnte nicht übernommen werden.",
				noModelHint: "Für Phasenbilder ist kein Modell konfiguriert.",
			},
			mediaLibrary: {
				description:
					"Alle Dateien, die für dieses Szenario erzeugt wurden — und über den Umschalter alle Dateien Ihres Unternehmens. Eine Datei kann in mehreren Szenarien verwendet werden; sie liegt dann nur einmal im Speicher.",
				pageTitle: "Medienbibliothek",
				descriptionGlobal:
					"Alle Dateien Ihres Unternehmens — erzeugt oder hochgeladen, über alle Szenarien hinweg. Zugewiesen wird im jeweiligen Szenario: Vorschaubild, großes Bild und Trailer im Szenario-Formular, Phaseninhalte im Phasen-Editor.",
				uploadedGroup: "Hochgeladen",
				uploadNew: "Datei hochladen",
				uploadFailed: "Der Upload ist fehlgeschlagen.",
				pickTitle: "Aus Medienbibliothek wählen",
				pickStyleTitle: "Grafischen Stil wählen",
				pickEmptyStyles:
					"Noch keine grafischen Stile in der Mediathek. Laden Sie ein Bild hoch — nach der Analyse erscheint es hier als grafischer Stil.",
				pickEmpty:
					"Für diesen Inhaltstyp ist noch nichts in der Bibliothek. Laden Sie eine Datei hoch oder erzeugen Sie Medien im Video-Assistenten.",
				origin: { uploaded: "Hochgeladen", styleReference: "Grafischer Stil" },
				choose: "Aus Medienbibliothek wählen",
				scopeScenario: "Dieses Szenario",
				scopeCompany: "Alle Szenarien",
				empty: "Für dieses Szenario wurde noch nichts erzeugt.",
				noPreview: "Keine Vorschau",
				kindVideo: "Video",
				kindImage: "Bild",
				kindAudio: "Audio",
				kindFile: "Datei",
				kindTab: {
					all: "Alle",
					video: "Videos",
					image: "Bilder",
					audio: "Audio",
					other: "Sonstiges",
				},
				sortNewest: "Neueste zuerst",
				sortOldest: "Älteste zuerst",
				sortNameAsc: "Name A–Z",
				sortNameDesc: "Name Z–A",
				closePreview: "Vorschau schließen",
				filterAllScenarios: "Alle Szenarien",
				roleTrailer: "Intro-Video",
				roleContent: "Phaseninhalt",
				roleUnused: "Ungenutzt",
				roleElsewhere: "In {{times}} weiteren Szenarien",
				from: "aus „{{name}}“",
				useAsTrailer: "Als Intro-Video",
				removeFromScenario: "Aus Szenario entfernen",
				download: "Herunterladen",
				downloadFailed: "Download fehlgeschlagen — bitte erneut versuchen.",
				delete: "Löschen",
				actionFailed: "Die Aktion konnte nicht ausgeführt werden.",
				replaceTitle: "Intro-Video ersetzen?",
				replaceBody:
					"Dieses Szenario hat bereits ein Intro-Video. Das bisherige wird ersetzt — Teilnehmende sehen ab sofort das neue. Die Datei selbst bleibt erhalten und kann jederzeit wieder gewählt werden.",
				replaceConfirm: "Ersetzen",
				folders: {
					title: "Ordner",
					allFiles: "Alle Dateien",
					newFolder: "Neuer Ordner",
					open: "Ordner „{{name}}“ öffnen",
					files_one: "{{count}} Datei",
					files_other: "{{count}} Dateien",
					subfolders_one: "{{count}} Unterordner",
					subfolders_other: "{{count}} Unterordner",
					namePlaceholder: "Ordnername",
					rename: "Umbenennen",
					delete: "Ordner löschen",
					expand: "Aufklappen",
					collapse: "Zuklappen",
					deleteTitle: "Ordner „{{name}}“ löschen?",
					deleteBody:
						"Nur ein leerer Ordner kann gelöscht werden. Dateien werden mit einem Ordner nie gelöscht — verschieben Sie sie vorher oder ziehen Sie sie auf „Alle Dateien“.",
					deleteConfirm: "Löschen",
					includeSubfolders: "Unterordner einbeziehen",
					dropHint:
						"Ziehen Sie eine Datei auf einen Ordner, um sie dorthin zu verschieben. Auf „Alle Dateien“ gezogen wird sie wieder herausgenommen. Ein Ordner auf einem anderen Ordner wird darin einsortiert.",
					emptyFolder:
						"In diesem Ordner liegt noch nichts. Ziehen Sie eine Datei aus der Bibliothek hierher.",
				},
			},
			jobsCosts: {
				title: "Jobs & Kosten",
				columns: {
					job: "Job",
					type: "Typ",
					details: "Details",
					formats: "Formate",
					status: "Status",
					cost: "Kosten",
				},
				empty: "Für dieses Szenario wurden noch keine KI-Jobs ausgeführt.",
				scenarioTotal: "Kosten dieses Szenarios — inkl. Phasen-TTS und KI-Bildern",
				estimatePrefix: "~",
				phaseDetail: "Phase {{phase}} · {{variants}} Varianten · {{model}}",
				scenarioDetail: "{{variants}} Varianten · {{model}}",
				infra: {
					async: "Async-Job · Ergebnisse werden automatisch nachgeführt",
					registry: "Modell pro Use-Case austauschbar, ohne Code-Änderung",
					origin: "Origin: Hetzner Object Storage (DE)",
					cdn: "CDN: Bunny.net (EU)",
				},
				type: {
					PHASE_IMAGE: "Bilder",
					STORYBOARD: "Storyboard",
					SCENE_IMAGE: "Szenenbilder",
					NARRATION_PREVIEW: "Sprecher-Vorschau",
					NARRATION_TTS: "Sprachausgabe",
					SCENE_VIDEO: "Szenen-Videos",
					VIDEO_EXPORT: "Video-Export",
				},
				status: {
					QUEUED: "In Warteschlange",
					RUNNING: "Läuft",
					SUCCEEDED: "Fertig",
					FAILED: "Fehlgeschlagen",
					CANCELLED: "Abgebrochen",
				},
			},
			introVideo: {
				title: "Video-Assistent",
				description:
					"Geführter Ablauf in 6 Schritten: Storyboard → Stil & Beispielbilder → Narration → Audio → Szenen-Videos → Schnitt & Export. Das fertige Video können Sie als Intro des Szenarios verknüpfen oder in der Medienbibliothek ablegen und als Phaseninhalt verwenden.",
				inProgress: "Läuft — Schritt {{step}}",
				started: "Begonnen — Schritt {{step}}",
				archivedHeading: "Archivierte Assistenten",
				archivedRow: "Archiviert am {{date}} · bis Schritt {{step}}",
				finished: "✓ Fertiggestellt",
				continue: "Assistent fortsetzen",
				openFinished: "Fertiges Video öffnen",
				spent: "Bisher angefallen",
				notStarted: "Noch nicht gestartet",
				steps: {
					storyboard: "Storyboard",
					storyboardHint:
						"Prompt + Ziellänge → klare Anweisung pro Szene: was zu sehen ist & wie lang",
					style: "Stil & Beispielbilder",
					styleHint:
						"Grafischen Stil wählen → Beispielbild + Beschreibung pro Szene, einzeln iterierbar",
					narration: "Narration",
					narrationHint: "Sprechertext wie ein Trailer — schreiben, prüfen, mit Feedback iterieren",
					audio: "Audio",
					audioHint: "Sprecherstimme wählen, Untertitel-Stil, Text vertonen",
					sceneVideos: "Szenen-Videos",
					sceneVideosHint: "Jede Szene separat generieren, prüfen, iterieren, freigeben",
					cutExport: "Schnitt & Export",
					cutExportHint: "Kürzen, Reihenfolge ändern, zu einem Video zusammenfügen",
					storyboardEstimate: "~$0,02",
					styleEstimate: "~$0,28",
					narrationEstimate: "~$0,02",
					audioEstimate: "~$0,10",
					sceneVideosEstimate: "~$3,60",
					cutExportEstimate: "~$0,10",
				},
				forecast: "Prognose gesamt (Kalkulationsrahmen $3–6 pro 30-s-Video)",
				forecastValue: "~$4,10",
				start: "Assistent starten",
			},
			tts: {
				uploadFile: "Datei hochladen",
				generateFromText: "Aus Text generieren",
				textToConvert: "Text zur Sprachausgabe",
				textPlaceholder: "Geben Sie den Text ein, der in dieser Phase gesprochen werden soll...",
				voiceLanguage: "Sprachfilter",
				allLanguages: "Alle Sprachen",
				voice: "Stimme",
				selectVoice: "Stimme auswählen",
				changeVoice: "Stimme ändern",
				noVoiceSelected: "Keine Stimme ausgewählt",
				voiceFilters: "Stimmen filtern",
				gender: "Geschlecht",
				age: "Altersgruppe",
				useCase: "Anwendungsfall",
				category: "Kategorie",
				previewVoice: "Vorschau",
				confirmVoice: "Stimme wählen",
				allGenders: "Alle Geschlechter",
				allAges: "Alle Altersgruppen",
				allUseCases: "Alle Anwendungsfälle",
				allCategories: "Alle Kategorien",
				searchPlaceholder: "Stimme suchen …",
				noVoices: "Keine Stimmen für diese Filter gefunden.",
				values: {
					male: "Männlich",
					female: "Weiblich",
					neutral: "Neutral",
					young: "Jung",
					middle_aged: "Mittleres Alter",
					old: "Älter",
					conversational: "Dialog",
					informative_educational: "Informativ & Schulung",
					narrative_story: "Erzählung",
					entertainment_tv: "Unterhaltung & TV",
					social_media: "Social Media",
					characters_animation: "Figuren & Animation",
					advertisement: "Werbung",
					professional: "Professionell",
					premade: "Standard",
					cloned: "Geklont",
					generated: "Generiert",
					american: "Amerikanisch",
					british: "Britisch",
					australian: "Australisch",
					irish: "Irisch",
					swedish: "Schwedisch",
					transatlantic: "Transatlantisch",
					standard: "Standard",
				},
				generateAudio: "Audio generieren",
				generating: "Generierung läuft...",
				generateError: "Audiogenerierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
			},
			mustBeSet: {
				phaseEndText: "Abschlussnachricht muss festgelegt werden",
				decisionOption: "Entscheidungsoption muss festgelegt werden",
				decisionName: "Entscheidungsname muss festgelegt werden",
				timeLeftDecision: "Entscheidung über verbleibende Zeit muss festgelegt werden",
				timeLimit: "Zeitlimit muss festgelegt werden",
				confirmationRequired: "Bestätigung erforderlich muss festgelegt werden",
			},
		},
		tutorials: {
			title: "Titel",
		},
		phaseNode: {
			audioContent: "Audiodatei",
			phaseName: "Unbenannte Phase",
			spoilerAvailable: "Spoiler verfügbar",
			delayedContentAvailable: "Inhalt mit Zeitverzögerung verfügbar",
			decisionsOptions: "Entscheidungsmöglichkeiten",
			decisionsOption: "Entscheidungsmöglichkeit",
			nextPhase: "Führt zur nächsten Phase",
			newPhase: "Neue Phase",
			invalidNode: "Diese Phase hat Validierungsfehler",
			validationError: {
				contentRequired: "Inhalt ist erforderlich",
				decisionOptionRequired: "Entscheidungsoption muss ausgefüllt sein",
				decisionNameRequired: "Entscheidungsname muss ausgefüllt sein",
				timeLeftDecisionRequired: "Zeitüberschreitungsentscheidung muss gesetzt sein",
				timeLimitRequired: "Zeitlimit muss gesetzt sein",
				confirmationRequired: "Bestätigungstyp ist bei mehreren Optionen erforderlich",
				phaseEndTextRequired: "Phasenendtext muss gesetzt sein",
				endTimeInvalid: "Endzeit muss mindestens 10s nach Startzeit liegen",
				generic: "Ungültiges Feld: {{path}}",
			},
		},
		editor: {
			rightPanel: {
				graph: "Ablauf",
				introVideo: "Video (KI)",
				media: "Medien",
				jobsCosts: "Jobs & Kosten",
				versions: "Versionen",
			},
			publish: {
				statusDraft: "Entwurf",
				statusActive: "Aktiv",
				unpublishedChanges: "Änderungen nicht veröffentlicht",
				nothingLive: "noch nichts",
				unnamedVersion: "Version {{id}}",
				draftName: "Ihren unveröffentlichten Entwurf",
				editingDraft:
					"Veröffentlichte Fassung: {{published}}. Sie bearbeiten: {{editing}} — veröffentlichen Sie ihn, damit die Änderungen zählen.",
				editingLive: "Veröffentlichte Fassung: {{published}}. Genau diesen Stand bearbeiten Sie.",
				publish: "Veröffentlichen",
				publishTitle: "Dieses Szenario veröffentlichen?",
				publishWarning:
					"Der gespeicherte Entwurf wird ab sofort von allen Teilnehmenden gespielt — in der Web-App und in VR — in jeder neu gestarteten Sitzung. Laufende Trainings sind nicht betroffen.",
				publishFirstWarning:
					"Dieses Szenario wurde noch nie veröffentlicht. Mit dem Veröffentlichen wird es für Teilnehmende erstmals sichtbar — in der Web-App und in VR. Laufende Trainings sind nicht betroffen.",
				republishWarning:
					"Die zuvor veröffentlichte Fassung geht wieder an die Teilnehmenden — in der Web-App und in VR. Seit dem Zurückziehen hat sich nichts geändert.",
				publishConfirm: "Veröffentlichen",
				publishFailed: "Das Szenario konnte nicht veröffentlicht werden. Bitte erneut versuchen.",
				incomplete: "Das Szenario ist noch nicht vollständig — {{issues}}",
				issuePhase: "Phase {{number}}{{name}}",
				issueScenario: "Szenario",
				issueLine: "{{where}}: {{fields}} fehlt",
				problem: {
					UNKNOWN_TARGET: "eine Option führt zu Phase {{target}}, die es nicht gibt",
					FALLBACK_NOT_AN_OPTION:
						"die automatisch gewählte Option bei Zeitüberschreitung (Phase {{target}}) ist keine Option dieser Phase",
					NO_START: "keine Startphase — jede Phase wird von einer Option angesteuert",
					SEVERAL_STARTS:
						"mehrere Startphasen ({{phases}}) — genau eine Phase darf von keiner Option angesteuert werden",
					START_WITHOUT_DECISION: "die Startphase braucht eine Entscheidung",
				},
				field: {
					content: "Inhalt",
					phaseName: "Name der Phase",
					scenarioName: "Name des Szenarios",
					contentType: "Inhaltstyp",
					decisionName: "Name der Entscheidung",
					decisionOptions: "Entscheidungsoptionen",
					title: "Titel",
					structure: "Aufbau",
				},
				unpublish: "Veröffentlichung zurückziehen",
				unpublishTitle: "Veröffentlichung zurückziehen?",
				unpublishWarning:
					"Das Szenario wird für Teilnehmer — auch VR — ausgeblendet; laufende Trainings sind nicht betroffen. Es kann jederzeit wieder veröffentlicht werden.",
				unpublishConfirm: "Zurückziehen",
				unpublishFailed:
					"Die Veröffentlichung konnte nicht zurückgezogen werden. Bitte erneut versuchen.",
				unreachable: "Der Server ist nicht erreichbar — am Szenario wurde nichts geändert.",
			},
			versions: {
				saveHeading: "Live-Stand als Version sichern",
				saveHint:
					"Sichert den derzeit veröffentlichten Stand als benannte Version, zu der Sie zurückkehren können. Ihre unveröffentlichten Änderungen liegen im Entwurf darüber und sind nicht enthalten.",
				labelPlaceholder: "Bezeichnung, z. B. „vor der Überarbeitung im März“",
				save: "Version speichern",
				loading: "Versionen werden geladen …",
				empty:
					"Noch nichts veröffentlicht — mit dem Veröffentlichen des Entwurfs entsteht die erste Version.",
				emptyButLive:
					"Dieses Szenario ist aktiv, wurde aber veröffentlicht, bevor Versionen festgehalten wurden — daher noch keine Historie. Die nächste Veröffentlichung hält eine fest.",
				draftHeading: "Arbeitsstand",
				draftBadge: "Entwurf",
				draftHint:
					"Alles, was Sie speichern, landet hier. Gespielt wird es erst nach dem Veröffentlichen — der Button dafür ist in der Leiste unten.",
				lastPublished: "Zuletzt veröffentlicht",
				saved: "Gespeichert als",
				untitled: "Version {{id}}",
				active: "Aktiv",
				publishedAt: "Veröffentlicht am {{date}}",
				createdAt: "Erstellt {{date}}",
				createdBy: "von {{name}}",
				rename: "Umbenennen",
				renameTitle: "Version umbenennen",
				renameSave: "Bezeichnung speichern",
				publish: "Veröffentlichen",
				publishTitle: "Diese Version veröffentlichen?",
				publishWarning:
					"„{{label}}“ wird ab sofort von allen Teilnehmenden gespielt — in der Web-App und in VR, auch in neu gestarteten Sitzungen. Der aktuelle Stand wird als eigene Version gesichert.",
				publishConfirm: "Veröffentlichen",
				delete: "Löschen",
				view: "Vorschau",
				deleteTitle: "Diese Version löschen?",
				deleteWarning:
					"„{{label}}“ wird endgültig aus der Historie entfernt. Was Teilnehmende spielen, bleibt davon unberührt.",
				deleteConfirm: "Löschen",
				unreachable: "Der Server ist nicht erreichbar — es wurde nichts geändert.",
				deleteFailed: "Die Version konnte nicht gelöscht werden. Bitte erneut versuchen.",
				saveFailed: "Die Version konnte nicht gespeichert werden. Bitte erneut versuchen.",
				renameFailed: "Die Bezeichnung konnte nicht gespeichert werden. Bitte erneut versuchen.",
				publishFailed: "Die Version konnte nicht veröffentlicht werden. Bitte erneut versuchen.",
			},
			newPhase: "Neue Phase",
			newContent: "Neuer Inhalt",
			searchPhases: "Phasen suchen...",
			noResults: "Keine passenden Phasen",
			deletePhaseTitle: "Phase löschen",
			deletePhaseConfirmationUnnamed:
				"Möchten Sie diese Phase wirklich löschen? Alle ihre Verbindungen werden entfernt.",
			deletePhaseConfirmation:
				'Möchten Sie die Phase "{{phaseName}}" wirklich löschen? Alle Verbindungen werden entfernt.',
			staleDraft: {
				title: "Der Entwurf wurde inzwischen geändert",
				text: "Seit Sie den Editor geöffnet haben, wurde der Entwurf gespeichert – in einem anderen Fenster oder von einem KI-Client. Neu laden zeigt den neueren Stand (Ihre Änderungen gehen verloren), Trotzdem speichern überschreibt ihn mit Ihrem.",
				reload: "Neu laden",
				overwrite: "Trotzdem speichern",
				keepEditing: "Abbrechen",
			},
			unsavedChanges: "Ungespeicherte Änderungen",
			unsavedChangesWarning:
				"Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
			discardChanges: "Änderungen verwerfen",
			emptyStateHint:
				"Klicken Sie auf eine Phase zum Bearbeiten oder ziehen Sie eine neue aus der Seitenleiste",
			sectionContent: "Inhalt",
			sectionEndConditions: "Endbedingungen",
			sectionDecisions: "Entscheidungen",
			sectionSpoiler: "Spoiler",
			sectionTimeDelayed: "Zeitverzögerter Inhalt",
			sectionEffects: "Effekte",
			decisionsCount: "{{count}} Entscheidung(en)",
			delayedItemsCount: "{{count}} Element(e)",
			toggleDecisionLabels: "Entscheidungslabels ein-/ausblenden",
			undo: "Rückgängig",
			redo: "Wiederholen",
			autoLayout: "Automatisches Layout",
			invalidNode: "Diese Phase hat Validierungsfehler",
		},
		course: {
			title: "Szenario",
			subtitle: "Verwalten Sie Ihr Szenario.",
			tabs: {
				general: "Allgemein",
				user: "Benutzer",
				roles: "Benutzerrollen",
			},
			courseInformation: "Szenarioinformationen",
			"all-scenarios": "Alle Szenarien",
			"get-started": "Los geht's",
			"for-whom": "Für wen",
			"related-scenarios": "Verwandte Szenarien",
			"no-related-scenarios": "Keine verwandten Szenarien",
			"see-details": "Siehe Details",
			overview: "Übersicht",
			"no-tag": "Keine Markierung",
		},
		analytics: {
			"page-title": "Berichte",
			export: "Exportieren",
			"only-the-protocol": "Nur das Protokoll",
			"protocol-with-related-content": "Das Protokoll mit offengelegtem Inhalt",
			"delete-scenario-progress-title": "Szenariofortschritt löschen",
			"file-export-error": "Beim Exportieren einer Datei ist ein Fehler aufgetreten",
			"sure-want-to-delete-report":
				"Möchten Sie wirklich den Bericht über den Abschluss des Szenarios '{{courseName}}' für den Zeitraum '{{period}}' löschen?",
		},
		dashboard: {
			title: "Willkommen",
		},
		mediaCosts: {
			title: "KI-Kosten",
			description:
				"Was Ihr Unternehmen für KI-generierte Medien ausgegeben hat — Phasenbilder, Phasen-Sprachausgabe, erzeugte Videos und Bibliothekstitel. Die Zahlen stammen aus dem Kostenjournal und ändern sich nicht rückwirkend.",
			total: "Gesamtsumme im Zeitraum",
			empty: "Für diesen Zeitraum sind keine Kosten erfasst.",
			byCourse: "Nach Szenario",
			byUseCase: "Nach Anwendungsfall",
			byMonth: "Nach Monat",
			deletedScenario: "Gelöschtes Szenario (#{{id}})",
			courselessHint:
				"{{amount}} entfallen auf Ausgaben ohne Szenario — etwa erzeugte Bibliothekstitel. Diese Aufstellung ergibt deshalb weniger als die Gesamtsumme.",
			columns: {
				scenario: "Szenario",
				useCase: "Anwendungsfall",
				month: "Monat",
				amount: "Betrag",
			},
			window: {
				from: "Von",
				to: "Bis",
				reset: "Zeitraum zurücksetzen",
				applied: "Angezeigter Zeitraum: {{from}} bis {{to}}",
				defaultHint: "Ohne Angabe werden die letzten zwölf Kalendermonate ausgewertet.",
			},
		},
		mediaPresets: {
			title: "Formate & Presets",
			description:
				"Zentrale Verwaltung der Ausgabeformate und der KI-Modell-Registry. Ein Modell hinzufügen oder einen Preis ändern ist eine Einstellung — keine Code-Änderung.",
			unverifiedPricing: {
				title: "{{count}} Modell(e) mit ungeprüften Preisen",
				description:
					"Die hinterlegten Preise stammen aus dem Entwurf und sind Platzhalter. Kostenschätzungen bleiben als ungeprüft markiert, bis der Preis gegen die tatsächliche Anbieterpreisliste geprüft und bestätigt wurde.",
			},
			music: {
				title: "Musikbibliothek",
				description:
					"Hintergrundmusik für erzeugte Videos. Die Bibliothek ist global: Alle Unternehmen wählen aus dieser einen Liste, und nur die Plattform-Administration kann sie ändern.",
				empty: "Noch keine Titel in der Bibliothek.",
				uploadTitle: "Titel hochladen",
				generateTitle: "Titel erzeugen",
				editTitle: "Titel bearbeiten",
				licenceMissing: "Keine Lizenz hinterlegt",
				licenceWarning:
					"{{times}} Titel ohne hinterlegte Lizenz. Bitte ergänzen — eine Bibliothek ohne Lizenznachweis ist nicht einsetzbar.",
				generateCostHint:
					"Die Erzeugung ist kostenpflichtig und wird dem Unternehmen belastet, das sie auslöst — ohne Zuordnung zu einem Szenario. Der Titel erscheint hier, sobald die Audiodatei vorliegt.",
				columns: {
					track: "Titel",
					origin: "Herkunft",
					duration: "Länge",
					licence: "Lizenz",
				},
				origin: {
					uploaded: "Hochgeladen",
					generated: "KI-generiert",
				},
				actions: {
					upload: "Titel hochladen",
					generate: "Titel erzeugen",
					generateSubmit: "Erzeugen",
					play: "Anhören",
					stop: "Stopp",
				},
				fields: {
					name: "Titel",
					namePlaceholder: "Spannungsaufbau",
					description: "Beschreibung",
					descriptionPlaceholder: "Dezent, ansteigend",
					file: "Audiodatei",
					fileHint: "MP3 oder WAV. Die Datei wird in der eigenen Ablage gespeichert.",
					prompt: "Beschreibung für die Erzeugung",
					promptPlaceholder:
						"Ruhige, flächige Hintergrundmusik ohne Gesang, dezent ansteigend, sachlicher Charakter.",
					durationSeconds: "Länge (Sekunden)",
					licence: "Lizenz",
					licencePlaceholder: "z. B. CC0 oder Name des Lizenzgebers",
					licenceGeneratedPlaceholder: "Leer lassen für die Anbieterlizenz",
					licenceHint:
						"Pflichtangabe. Halten Sie fest, unter welcher Lizenz der Titel eingesetzt werden darf.",
					licenceGeneratedHint:
						"Optional. Bleibt das Feld leer, wird der Titel unter den Lizenzbedingungen des Anbieters geführt.",
				},
			},
			formats: {
				title: "Ausgabeformate",
				description:
					"Globale Presets gelten für alle Unternehmen. Unternehmen können eigene Presets anlegen und globale ausblenden.",
				empty: "Noch keine Formate angelegt.",
				createTitle: "Format anlegen",
				editTitle: "Format bearbeiten",
			},
			models: {
				title: "KI-Modell-Registry",
				description:
					"Ein Modell pro Anwendungsfall ist Standard. Preis, EU-Nachweis und Verfügbarkeit werden hier gepflegt.",
				empty: "Noch keine Modelle registriert.",
				editTitle: "Modell bearbeiten",
			},
			columns: {
				label: "Bezeichnung",
				dimensions: "Maße",
				aspectRatio: "Seitenverhältnis",
				mediaKind: "Medientyp",
				scope: "Geltungsbereich",
				status: "Status",
				model: "Modell",
				provider: "Anbieter",
				price: "Preis",
			},
			fields: {
				key: "Schlüssel",
				label: "Bezeichnung",
				width: "Breite (px)",
				height: "Höhe (px)",
				aspectRatio: "Seitenverhältnis",
				mediaKind: "Medientyp",
				displayName: "Anzeigename",
				unitPriceUsd: "Preis pro Einheit (USD)",
				unitPriceHint: "Wird für jede Kostenschätzung und Abrechnung im Produkt verwendet.",
				pricesVerified: "Preis geprüft",
				pricesVerifiedHint:
					"Erst aktivieren, wenn der Preis gegen die aktuelle Anbieterpreisliste geprüft wurde.",
				enabled: "Aktiv",
			},
			mediaKind: {
				image: "Bild",
				video: "Video",
				both: "Bild & Video",
			},
			scope: {
				global: "Global",
				company: "Unternehmen",
			},
			status: {
				enabled: "Aktiv",
				disabled: "Inaktiv",
				default: "Standard",
				priceUnverified: "Preis ungeprüft",
			},
			useCase: {
				phase_image: "Phasenbild",
				storyboard: "Storyboard",
				scene_image: "Szenenbild",
				narration_tts: "Sprecherstimme",
				scene_video: "Szenen-Video",
				video_export: "Video-Export",
				music: "Hintergrundmusik",
			},
			provider: {
				openai: "OpenAI",
				elevenlabs: "ElevenLabs",
				black_forest: "Black Forest Labs",
				openrouter: "OpenRouter",
				fal: "fal.ai",
				self_hosted: "Self-Hosting",
				internal: "Intern",
			},
			unit: {
				per_image: "pro Bild",
				per_second: "pro Sekunde",
				per_scene: "pro Szene",
				per_1k_tokens: "pro 1.000 Tokens",
				per_track: "pro Spur",
				per_export: "pro Export",
			},
			actions: {
				addPreset: "Format hinzufügen",
				edit: "Bearbeiten",
				enable: "Aktivieren",
				disable: "Deaktivieren",
				delete: "Löschen",
				makeDefault: "Als Standard",
			},
		},
		aiGenerated: {
			badge: "KI-generiert",
			description:
				"Dieses Medium wurde vollständig von einer künstlichen Intelligenz erzeugt und zeigt keine realen Personen oder Ereignisse.",
		},
		sidebar: {
			mediaPresets: "Formate & Presets",
			mediaLibrary: "Medien",
			mediaCosts: "KI-Kosten",
			kpiDashboard: "KPI-Dashboard",
			users: "Benutzer",
			roles: "Benutzerrollen",
			logout: "Abmelden",
			accounts: "Konten",
			settings: "Einstellungen",
			accountSettings: "Kontoeinstellungen",
			profile: "Mein Profil",
			companies: "Organisationen",
			back: "Zurück zu deinem Account",
			all: "Alle",
			listViews: "Ansichten auflisten",
			campaigns: "Kampagnen",
			courses: "Szenarien",
			cybersecurityIncidentBasics: "Grundlagen der Cybersicherheitsvorfälle",
			company: "Unternehmen",
			tutorials: "Tutorials",
			menu: "Menü",
			analytics: "Berichte",
			"my-profile": "Mein Profil",
			"current-scenario": "Aktuelles Szenario",
		},
		errors: {
			scenarioInfoNotFound: "Die Szenarioinformationen wurden nicht gefunden",
			fileSizeExceeded: "Die Dateigröße überschreitet die maximale Größe von 100 MB",
			invalidEmail: "Ungültige E-Mail-Adresse",
			invalidPassword: "Ungültiges Passwort",
			passwordGuidelinesNotMet: "Passwortrichtlinien nicht erfüllt",
			termsAcceptanceMissing: "Bitte akzeptieren Sie die Nutzungsbedingungen",
			invalidValue: "Ungültiger Wert",
			invalidData: "Ungültige Daten",
			userNotConfirmed: "Benutzer nicht bestätigt",
			passwordMismatch: "Passwörter stimmen nicht überein",
			invalidToken: "Ungültiges Token",
			emailAlreadyTaken: "E-Mail-Adresse bereits vergeben",
			wentWrong: "Etwas ist schief gelaufen",
			unauthorized: "Nicht autorisiert",
			invalidAuthCode: "Ungültiger Authentifizierungscode",
			invalidOtp: "Ungültiges OTP",
			nameMissing: "Name fehlt",
			requiredFields: "Nicht alle erforderlichen Felder sind ausgefüllt.",
			expectedNumber: "Nummer erwartet / geben Sie 0 ein, wenn nicht benötigt.",
			customColumnAlreadyExists: "Spalte existiert bereits",
			wrongUrlShouldBeLinkedinProfile: "Falsche URL. Sollte eine LinkedIn-Profil-URL sein",
			notEnoughCredits: "Nicht genügend Credits",
		},
		mcpAuthorize: {
			title: "KI-Client verbinden",
			description: "{{client}} möchte im Szenario-Editor als {{user}} arbeiten.",
			canRead: "Szenarien, Versionen und die Medienbibliothek lesen",
			canEdit: "Szenarien anlegen, bearbeiten, veröffentlichen und löschen sowie Dateien hochladen",
			canPaid:
				"KI-Medien erzeugen – kostenpflichtig, jeweils erst nach Ihrer Bestätigung im Client",
			returnsTo: "Danach geht es zurück zu {{host}}.",
			revoke: "Unter Konto › Verbundene KI-Clients können Sie die Verbindung jederzeit trennen.",
			allow: "Zulassen",
			deny: "Ablehnen",
			notAllowed: "Nur Global Admins können KI-Clients mit dem Szenario-Editor verbinden.",
			back: "Zurück zum Client",
			invalid:
				"Diese Anfrage ist ungültig oder abgelaufen. Starten Sie die Verbindung im KI-Client neu.",
		},
		account: {
			mcpConnections: {
				title: "Verbundene KI-Clients",
				description: "Diese KI-Clients dürfen im Szenario-Editor als Sie arbeiten.",
				empty: "Kein KI-Client verbunden.",
				connected: "Verbunden am {{date}}",
				lastUsed: "zuletzt genutzt {{date}}",
				disconnect: "Trennen",
				guide: {
					title: "So verbinden Sie einen KI-Assistenten",
					intro:
						"Mit einem KI-Assistenten wie Claude oder ChatGPT können Sie Szenarien im Gespräch erstellen und bearbeiten. Der Assistent arbeitet als Sie und kann alles, was der Szenario-Editor kann. Verbinden können ihn nur Global Admins.",
					addressTitle: "Adresse des BCM360-Servers",
					copy: "Kopieren",
					copied: "Kopiert",
					copyAddress: "Adresse kopieren",
					copyCommand: "Befehl kopieren",
					claudeTitle: "Claude (claude.ai oder Claude Desktop)",
					claudeSteps: [
						"In Claude die Einstellungen öffnen und unter „Connectors“ einen eigenen Connector hinzufügen („Add custom connector“). Dafür ist ein Pro-, Max-, Team- oder Enterprise-Tarif nötig.",
						"Als Namen „BCM360“ eintragen und die Adresse von oben einfügen.",
						"Auf „Verbinden“ klicken: BCM360 öffnet sich. Wie gewohnt anmelden, auch mit Zwei-Faktor-Code, und „Zulassen“ wählen.",
						"Zurück in Claude stehen die BCM360-Werkzeuge bereit. Zum Ausprobieren: „Liste meine Szenarien.“",
					],
					claudeCodeTitle: "Claude Code",
					claudeCodeAfter:
						"Danach in Claude Code „/mcp“ eingeben, „bcm360“ wählen und anmelden – es öffnet sich dieselbe Seite mit „Zulassen“.",
					chatgptTitle: "ChatGPT",
					chatgptText:
						"In den Einstellungen unter „Connectors“ den Entwicklermodus einschalten, einen neuen Connector mit der Adresse von oben anlegen und als Anmeldung OAuth wählen. Danach öffnet sich BCM360 zum Anmelden und Zulassen.",
					goodToKnowTitle: "Gut zu wissen",
					goodToKnow: [
						"Der Assistent ändert nur den Entwurf. Teilnehmende sehen Änderungen erst nach dem Veröffentlichen.",
						"Kostenpflichtige Schritte wie KI-Bilder oder Sprachaufnahmen nennt der Assistent zuerst mit Preis und führt sie erst nach Ihrer Bestätigung aus.",
						"Arbeiten Sie gleichzeitig im Editor, meldet er einen inzwischen geänderten Entwurf, bevor etwas überschrieben wird.",
						"Eine Verbindung bleibt 30 Tage ohne Nutzung bestehen; danach einfach neu verbinden. Mit „Trennen“ beenden Sie sie sofort.",
					],
				},
			},
			connectionScraping: "LinkedIn-Verbindungen",
			enableConnectionScraping: "Scraping deiner LinkedIn-Verbindungen aktivieren",
			enableConnectionScrapingDescription:
				"Dies ermöglicht zu ermitteln zu welchen Prospects du oder deine Kollegen bereits eine Verindung auf Linkedin haben.",
			linkedinAutomation: "LinkedIn-Automatisierung",
			enableAutoAccept: "Auto-Akzeptieren aktivieren",
			enableAutoAcceptDescription: "Automatisches Akzeptieren von LinkedIn-Verbindungsanfragen",
			profileVisits: "Profilbesuche",
			warningPremiumAccountRequired: "Premium-Account erforderlich",
			enableProfileVisitsScraping: "Profilbesuche aktivieren",
			changePassword: "Passwort ändern",
			currentPassword: "Aktuelles Passwort",
			disableTwoFactorAuth: "2FA deaktivieren",

			emailOtpDescription:
				"Erhöhen Sie die Sicherheit Ihres Kontos mit einem einmaligen Code, der an Ihre E-Mail gesendet wird",
			enableTwoFactorAuth: "2FA aktivieren",
			enableTwoFactorAuthDescription: "Scannen Sie den QR-Code mit Ihrer Authentifizierungs-App",
			disableTwoFactorAuthDescription: "Geben Sie den Code aus Ihrer Authentifizierungs-App ein",
			profileSecurityDescription:
				"Erhöhen Sie die Sicherheit Ihres Kontos mit 2FA über eine Authentifizierungs-App",
			registerWithTwoFactorAuthDescription:
				"Es wird empfohlen, die Zwei-Faktor-Authentifizierung einzurichten, den QR-Code mit Ihrer Authentifizierungs-App zu scannen und den untenstehenden Code einzugeben",

			newPassword: "Neues Passwort",
			profileInformation: "Profilinformationen",
			profileSecurity: "Profilsicherheit",
			repeatPassword: "Neues Passwort wiederholen",
			tabs: {
				general: "Allgemein",
				notifications: "Benachrichtigungen",
				linkedinConnections: "LinkedIn-Verbindungen",
			},
			title: "Persönliche Informationen",
			description: "Aktualisieren Sie hier Ihre persönlichen Daten und Einstellungen.",
			save: "Änderungen speichern",
			saving: "Speichern...",
			cancel: "Abbrechen",
			linkedinConnections: "LinkedIn-Verbindungen",
		},
		basics: {
			create: "Erstellen",
			loading: "Wird geladen",
			none: "Teilnehmer",
			saveAndClose: "Speichern und schließen",
			selectColumns: "Spalten auswählen",
			wait: "Bitte warten",
			generate: "Generieren",
			reset: "Zurücksetzen",
			pleaseSelect: "Bitte wählen",
			noResults: "Keine Ergebnisse",
			account: "Konto",
			actions: "Aktionen",
			admin: "Admin",
			back: "Zurück",
			block: "Blockieren",
			cancel: "Abbrechen",
			change: "Bearbeiten",
			code: "Code",
			confirmationClose: "Sind Sie sicher, dass Sie das Fenster schließen wollen?",
			confirm: "Bestätigen",
			confirmPassword: "Passwort bestätigen",
			createSomething: "Erstelle {{something}}",
			delete: "Löschen",
			description: "Beschreibung",
			dragAndDropImage: "Ziehen & Ablegen",
			edit: "Bearbeiten",
			editSomething: "Bearbeite {{something}}",
			email: "E-Mail-Adresse",
			enterSomething: "Geben Sie {{something}} ein",
			firstName: "Vorname",
			home: "Startseite",
			label: "Etikett",
			lastName: "Nachname",
			linkedinUrl: "LinkedIn URL",
			logout: "Abmelden",
			name: "Name",
			noData: "Keine Daten",
			password: "Passwort",
			passwordGuidelines: {
				minimum: "Das Passwort muss mindestens 8 Zeichen enthalten",
				number: "Das Passwort muss mindestens eine Zahl enthalten",
				specialChar: "Das Passwort muss mindestens 1 Sonderzeichen enthalten",
				uppercase: "Das Passwort muss mindestens 1 Großbuchstaben enthalten",
				lowercase: "Das Passwort muss mindestens 1 Kleinbuchstaben enthalten",
			},

			permissions: "Berechtigungen",
			resetPassword: "Passwort zurücksetzen",
			role: "Rolle",
			save: "Speichern",
			saveChanges: "Änderungen speichern",
			search: "Suche {{something}}...",
			select: "Auswählen",
			selectSomething: "Wähle {{something}}",
			setPassword: "Passwort festlegen",
			status: "Status",
			termsAndConditions:
				"<noLink>Ich habe die</noLink> <link1>Allgemeinen Geschäftsbedingungen</link1> <noLink2>gelesen</noLink2>",
			privacyPolicy:
				"<noLink>Ich habe die</noLink> <link1>Datenschutzerklärung</link1> <noLink2>gelesen und akzeptiere sie</noLink2>",

			upload: "Hochladen",
			value: "Wert",
			warning: "Achtung",
			filter: "Filter",
			clear: "Alle Filter zurücksetzen",
			close: "Schließen",
			rows: "Rows",
			rowsOf: "von",
			rowsPerPage: "Zeilen pro Seite",
			columns: "Säulen",
			columnsShown: "Eingeblendete Säulen",
			export: "Export",
			next: "Nächste",
			previous: "Vorherige",
			addCriteria: "Kriterien hinzufügen",
			copyCriteria: "Kriterien kopieren",
			archive: "Archivieren",
			unarchive: "Archivieren aufheben",
			success: "Vorgang wird bearbeitet",
			goHome: "Zu den Szenarien",
			"enter-your": "Geben Sie Ihr ",
			"enter-your-firstname": "Geben Sie Ihren Vornamen ein",
			"enter-your-lastname": "Geben Sie Ihren Nachnamen ein",
			"enter-your-password": "Geben Sie Ihr Passwort ein",
			"enter-your-confirm-password": "Bestätigen Sie Ihr Passwort",
			"not-support-tag": "Ihr Browser unterstützt dieses Tag nicht.",
			thumbnail: "Vorschaubild",
			"thumbnail-description": "Dies ist das Vorschaubild auf der Szenarioüberichtsseite.",
			"trailer-video": "Trailer Video",
			"trailer-video-description": "Dies ist das Video auf der Szenariodetailsseite.",
			"large-image": "Großes Bild",
			"large-image-description": "Dies ist das große Bild auf der Szenariodetailsseite.",
			"content-scenario": "Inhalt des Szenarios",
			"confirm-invite-description":
				"Um die Einladung zu bestätigen, geben Sie bitte Ihre Daten ein",
			"invitation-expired": "Die Einladung ist abgelaufen",
			"invitation-token-invalid": "Einladungs-Token ist ungültig",
			"invitation-already-accepted": "Die Einladung wurde bereits angenommen",
			"accepting-invitation": "Annahme der Einladung",
			"update-pass-description": "Bitte wählen Sie ein Passwort, das noch nicht verwendet wurde. ",
			"request-error": "Fehler anfordern",
		},
		errorPages: {
			buttonText: "Zur Startseite",
			description:
				"Entweder haben Sie einen verdächtigen Weg probiert oder Sie sind versehentlich hierher gekommen. Egal was es ist, versuchen Sie es über die Navigation.",
			notFound: "404: Die Seite, die Sie suchen, ist hier nicht",
			serverError: "500: Interner Serverfehler",
			unauthorize: "401: Autorisierung erforderlich",
			forbidden: "403: Verboten",
		},
		forgotPassword: {
			forgotPasswordCta: "Link zum Zurücksetzen senden",
			submittedFeedbackMessage:
				"Überprüfen Sie Ihren Posteingang. Wir senden eine E-Mail mit Anweisungen, wie Sie Ihr Passwort zurücksetzen können!",
			title: "Passwort vergessen",
			description:
				"Bitte geben Sie Ihre registrierte E-Mail Adresse ein. Wir senden Ihnen dann einen Link zum Zurücksetzen.",
			send: "Senden Sie",
			"back-to-login": "Zurück zur Anmeldung",
		},
		inviteUser: {
			button: "Neuen Nutzer einladen",
			modal: {
				cta: "Einladen",
				emailPlaceholder: "E-Mail eingeben",
				firstNamePlaceholder: "Vorname eingeben",
				lastNamePlaceholder: "Nachname eingeben",
				rolePlaceholder: "Rolle auswählen",
				title: "Benutzer einladen",
			},
		},
		login: {
			emailPlaceholder: "Ihre E-Mail-Adresse",
			forgotPasswordCta: "Passwort vergessen?",
			loginCta: "Anmelden",
			passwordPlaceholder: "Ihr Passwort",
			invalidData: "E-Mail oder Passwort falsch",
			title: "Willkommen zurück",
			description: "Willkommen zurück! Bitte geben Sie Ihre Daten ein.",
			"check-email": {
				title: "Prüfen Sie Ihre E-Mail",
				description: "Wir haben einen Verifizierungslink an ",
				"enter-code": "Code manuell eingeben",
				"back-to-login": "Zurück zum Einloggen",
			},
			"remember-me": "Erinnern Sie sich an mich",
		},
		modals: {
			addAvatar: {
				description: "<underline>Klicken zum Hochladen</underline> oder ziehen und ablegen",
				fileSize: "Maximale Dateigröße ist 3 MB",
				title: "Datei hochladen",
			},
			deleteRole: {
				title: "Rolle löschen",
			},
			deleteUser: {
				title: "Benutzer löschen",
			},
			editUser: {
				rolePlaceholder: "Rollen auswählen",
				title: "Benutzer bearbeiten",
			},
		},
		emailOtp: {
			back: "Zurück",
			title: "E-Mail Verifizierung",
			description:
				"Wir haben einen 6-stelligen Code an Ihre E-Mail-Adresse gesendet. Bitte geben Sie den Code ein, um sich anzumelden.",
			code: "Verifizierungscode",
			codePlaceholder: "123456",
			cta: "Bestätigen",
			resend: "Code erneut senden",
			resending: "Wird gesendet...",
		},
		twoFA: {
			useEmailOtp: "Code per E-Mail erhalten",
			code: "Code",
			cta: "Bestätigen",
			title: "2FA-Code eingeben",
			description:
				"Bitte geben Sie den Bestätigungscode ein. Überprüfen Sie Ihre Authentifizierungsanwendung.",
		},
		users: {
			title: "Benutzer",
			search: "Benutzer suchen",
			resendInvite: "Einladung erneut senden",
			status: {
				expired: "Abgelaufen",
				active: "Aktiv",
				invited: "Eingeladen",
				blocked: "Gesperrt",
			},
		},
		userRoles: {
			title: "Rollen",
			button: "Benutzerrollen",
			modal: {
				create: {
					permissionPlaceholder: "Berechtigungen auswählen",
					title: "Rolle erstellen",
				},
				edit: {
					title: "Rolle aktualisieren",
				},
			},
			placeholders: {
				codePlaceholder: "Eingeben",
				namePlaceholder: "Name eingeben",
			},
		},
	},
};
